import { ServiceState } from 'components/system/models/ServiceState';
// eslint-disable-next-line import/default
import Service from 'system/Service';

import MarketplaceServiceModel from './models/MarketplaceProject';

const MarketplaceService = Service.extend({
    name: 'marketplace',

    serviceAvailabilityFeatureName: 'MARKETPLACE_SERVICE',

    constructor: function MarketplaceService() {
        MarketplaceService.parent.call(this, {
            serviceState: new ServiceState({
                createSingleModelInstance: () => new MarketplaceServiceModel(),
                fetchSingleModelInstance: () =>
                    MarketplaceServiceModel.findOne(),
            }),
        });
    },
});

export default MarketplaceService;
